import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from '../../../providers/firebase/firebase';

interface UseGateOperatorAccountsResult {
    accountIds: string[];
    loading: boolean;
}

/**
 * Live view of gate_operators/{uid}.account_ids — the polymarket accounts
 * the signed-in user may clear gates for. [] when unassigned.
 */
export function useGateOperatorAccounts(): UseGateOperatorAccountsResult {
    const [uid, setUid] = useState<string | null>(null);
    const [accountIds, setAccountIds] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const auth = getAuth();
        if (auth.currentUser) setUid(auth.currentUser.uid);
        return onAuthStateChanged(auth, u => setUid(u?.uid ?? null));
    }, []);

    useEffect(() => {
        if (!uid) return;
        const unsub = onSnapshot(
            doc(db, `gate_operators/${uid}`),
            snap => {
                const ids = snap.exists()
                    ? (snap.data().account_ids as string[] | undefined)
                    : undefined;
                setAccountIds(Array.isArray(ids) ? ids : []);
                setLoading(false);
            },
            () => {
                // Read denied (e.g. rules changed mid-session): treat as unassigned.
                setAccountIds([]);
                setLoading(false);
            }
        );
        return () => unsub();
    }, [uid]);

    return { accountIds, loading };
}
